import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from "@angular/material/snack-bar";
import type {Notification} from "../notification.model"

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationComponent {
  private snackBar = inject(MatSnackBar);
  data = inject<Notification>(MAT_SNACK_BAR_DATA);


  title;
  body;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.body = data.body;
  }

  dismiss() {
    this.snackBar.dismiss();
  }

}
